/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_GenericInputs */

const en_common_error_generic = /** @type {(inputs: Common_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Try again.`)
};

const id_common_error_generic = /** @type {(inputs: Common_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang salah. Coba lagi.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Try again." |
*
* @param {Common_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const common_error_generic = /** @type {((inputs?: Common_Error_GenericInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_GenericInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_error_generic(inputs)
	return en_common_error_generic(inputs)
});